import React, { useEffect, useState } from "react";
import "./Navbar.css";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Avatar from "@mui/material/Avatar";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { MyContextSupply } from "../../Context";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Rightheader from "./Rightheader";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Popper, Paper, Divider } from "@mui/material";
// import  from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import "react-toastify/dist/ReactToastify.css";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { GrUserExpert, GrUserAdmin } from "react-icons/gr";
import { RiShoppingBag3Line } from "react-icons/ri";
import SearchInput from "./SearchInput";
import AdminValidation from "./AdminValidation";

const Navbar = () => {
  const {
    account,
    token,
    isAdmin,
    cartItems,
    totalItem,
    logoutUser,
    path,
    setPath,
    runPath,
    toggleRunPath,
    adminValidation,
    allProducts
  } = MyContextSupply();
  const navigate = useNavigate();
  const location = useLocation();
  const [text, setText] = useState("");
  const [liHidden, setLiHidden] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isAdminRouteClick, setIsAdminRouteClick] = useState(false);
  const [inputValue, setInputValue] = useState("");


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { fname, carts } = account && account;

  const getText = (event) => {
    const values = event.target.value;
    setText(values);
    setLiHidden(false);
  };
  // console.log(text);

  // collecting the path from below useEffect
  useEffect(() => {
    setPath(location.pathname);
  }, [runPath, path]);
  // console.log(path);

  // this function for varifying admin, if already verified then navigate to admin dashboard otherwise give pin popup form
  const toggleAdminLinkClick = () => {
    if (token.length !== 0 && isAdmin && adminValidation === "verified") {
      navigate("/admin");
      toggleRunPath();
    }
    setIsAdminRouteClick(true);
  };

  return (
    <header>
      <nav>
        <div className="left">
          <IconButton onClick={() => setDrawerOpen(true)} className="hamburgur">
            <MenuIcon style={{ color: "white" }} />
          </IconButton>
          <Drawer open={drawerOpen}>
            <Rightheader
              toggleAdminLinkClick={toggleAdminLinkClick}
              inputValue={inputValue}
              setInputValue={setInputValue}
              isAdminRouteClick={isAdminRouteClick}
              setIsAdminRouteClick={setIsAdminRouteClick}
              setDrawerOpen={setDrawerOpen}
              handleClose={handleClose}
            />
          </Drawer>
          <div className="navlogo">
            <Link to="/" onClick={toggleRunPath}>
              <img
                src="https://png.monster/wp-content/uploads/2022/02/png.monster-764-370x370.png"
                alt=""
                className="nav-logo-s"
              />
            </Link>
          </div>
          <div className="nav_searchbaar">
            <SearchInput getText={getText} />
            {/* search filter */}
            {text && (
              <List className="extrasearch" hidden={liHidden}>
                <div className="overflow-search-items">
                {allProducts
                  ?.filter((product) => {
                    return product.title.longTitle
                      .toLowerCase()
                      .includes(text.toLowerCase());
                  })
                  .map((product) => {
                    console.log(product)
                    return (
                      <>
                      <ListItem key={product._id}>
                        <NavLink
                          to={`/getproductsone/${product._id}`}
                          onClick={() => {
                            setLiHidden(true);
                            setText("");
                            toggleRunPath();
                          }}
                        >
                          {product.title.longTitle}
                        </NavLink>
                      </ListItem>
                      <Divider />
                      </>
                    );
                  })}
                  </div>
              </List>
            )}
            {/* end of search filter method */}
          </div>
        </div>
        <div className="right">
          <div className="nav_btn">
            <NavLink to="/" onClick={toggleRunPath}>
              Home
            </NavLink>
          </div>
          {token.length === 0 && (
            <div className="nav_btn">
              <NavLink to="/login" onClick={toggleRunPath}>
                Signin
              </NavLink>
            </div>
          )}

          <NavLink to="/buynow" onClick={toggleRunPath}>
            <span className="cart-speacing">
              <Badge
                badgeContent={cartItems.length !== 0 ? totalItem : 0 || "0"}
                color="primary"
              >
                <div className="cart_btn">
                  <ShoppingCartIcon id="icon" />
                </div>
              </Badge>
            </span>
          </NavLink>

          {account !== undefined ? (
            <Avatar
              className="avtar"
              style={{ background: "blue" }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              {fname && fname[0]?.toUpperCase()}
            </Avatar>
          ) : (
            <Avatar
              className="avtar"
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            />
          )}
          <Popper open={Boolean(anchorEl)} anchorEl={anchorEl} disablePortal>
            <Paper>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                disableScrollLock={true}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                className="menubigScreen"
              >
                {token.length !== 0 ? (
                  <NavLink
                    to="/personalinfo"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      handleClose();
                      toggleRunPath();
                    }}
                  >
                    <MenuItem>
                      <GrUserExpert style={{ marginRight: "5px" }} /> My account
                    </MenuItem>
                  </NavLink>
                ) : (
                  <NavLink
                    to="/login"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      handleClose();
                      toggleRunPath();
                    }}
                  >
                  <MenuItem><GrUserExpert style={{ marginRight: "5px" }} /> My account</MenuItem>
                  </NavLink>
                )}
                {token.length !== 0 && isAdmin && (
                  <div className="admin-dashboard-navigation">
                    <MenuItem
                      onClick={() => {
                        // handleClose();
                        toggleAdminLinkClick();
                        toggleRunPath();
                      }}
                    >
                      <GrUserAdmin style={{ marginRight: "5px" }} /> Admin
                      Dashboard
                    </MenuItem>
                    <AdminValidation
                      isAdminRouteClick={isAdminRouteClick}
                      setIsAdminRouteClick={setIsAdminRouteClick}
                      handleClose={handleClose}
                      inputValue={inputValue}
                      setInputValue={setInputValue}
                      setDrawerOpen={setDrawerOpen}
                    />
                  </div>
                )}
                {account && (
                  <NavLink
                    to="/buynow"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      handleClose();
                      toggleRunPath();
                    }}
                  >
                    <MenuItem>
                      <RiShoppingBag3Line style={{ marginRight: "5px" }} />{" "}
                      Order to Purchase
                    </MenuItem>
                  </NavLink>
                )}
                {account && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      logoutUser(navigate);
                      toggleRunPath();
                    }}
                  >
                    <LogoutIcon style={{ fontSize: "16px", marginRight: 3 }} />
                    Logout
                  </MenuItem>
                )}
              </Menu>
            </Paper>
          </Popper>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
